// ContactType Request
export interface ContactTypeRequest {
  PolicyId: string;
  VersionNum: string;
  ContactId?: string;
}

//Save Equipment Request

export interface SaveEquipment {
  PolicyId: number;
  VersionNum: number;
  Contact: Contact;
}
export interface Contact {
  ContactId: number;
  ContactType: string;
  ContactName: string;
  Provision: string;
  Address: EquipmentAddress;
  EquipmentList: EquipmentList[];
}
export interface EquipmentAddress {
  StreetAddress: string;
  ZipCode: string;
  StateCode: string;
  City: string;
}

export interface EquipmentList {
  EquipmentId: number;
}

//Contact Type Response

export interface ContactTypeResponse {
  Contacts: Contact[];
  Status: string;
  Warnings: any[];
  Errors: any[];
}

export interface Contact {
  ContactId: number;
  ContactType: string;
  ContactName: string;
  EquipmentList: EquipmentList[];
}
export interface EquipmentList {
  EquipmentId: number;
  EquipmentDescription: string;
}

// Equipment List Response

export interface EquipmentList {
  EquipmentList: EquipmentList[];
  Status: string;
  Warnings: any[];
  Errors: any[];
}

export interface EquipmentList {
  EquipmentId: number;
  EquipmentDescription: string;
}
